import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import TopMenu from '../admin/TopBar';
import UploadImage from '../utils/UploadImage';
import { appDatabasePrimaryFunctions, base } from '../../base';
import '../../styles/css/AdminMain.css';
import { Toast, ErrorMessage, WarningMessage } from '../utils/HelpfulFunction';
import BasicDropzone from '../utils/Dropzone';
import Preview from "../utils/PreviewHomeScreen";
import { experiencePath, getScope, subscribeToScope, registerScopeGuard } from '../utils/experienceScope';

class SetUpHomeScreen extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();
        this.state = {
            itemsList: [],
            loading: true,
            modal: false,
            itemName: "",
            itemLink: "",
            imageUrl: "",
            itemToEdit: null,
            editingItem: false,
            buttonType: 'isWebsiteLink',
            openOutsideApp: false,
            backgroundImage: null,
            hasUnsavedChanges: false,
            buttonSizeRatio: 1,
            enabledModules: {},
            hideScoreboard: false,
            // The working scope, owned by utils/experienceScope: a ?experience=
            // in the URL wins, else this admin's stored choice, else '' for the
            // default experience. The top-bar switcher drives it.
            selectedExperience: getScope()
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.bindData = this.bindData.bind(this);
        this.handleExperienceChange = this.handleExperienceChange.bind(this);
    }

    async componentDidMount() {
        this.unsubscribeScope = subscribeToScope(id => this.handleExperienceChange(id));
        this.unregisterScopeGuard = registerScopeGuard(() => !this.state.hasUnsavedChanges);
        await this.bindData();

        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    async bindData() {
        const { selectedExperience } = this.state;
        this.homeButtonsBuiltRef = base.bindToState(experiencePath(selectedExperience, 'homeButtonsBuilt'), {
            context: this,
            state: 'itemsList',
            query: {
                orderByChild: 'order'
            },
            asArray: true,
            then() {
                this.setState({ loading: false });
            },
            catch(e) {
                this.setState({ loading: false });
            }
        });

        const backgroundImage = await appDatabasePrimaryFunctions.ref(experiencePath(selectedExperience, 'settings/backgroundImage')).once('value');
        if (backgroundImage.exists()) {
            this.setState({ backgroundImage: backgroundImage.val() });
        }

        // Fetch enabled modules from settings
        const modulesSnapshot = await appDatabasePrimaryFunctions.ref(experiencePath(selectedExperience, 'settings/modules')).once('value');
        if (modulesSnapshot.exists()) {
            this.setState({ enabledModules: modulesSnapshot.val() });
        }

        // The scoreboard is not a Settings module: Settings has its own Hide
        // Scoreboard switch, which hides it wherever it sits in this layout. Read
        // it so the Scoreboard item can say when fans will not see it.
        const hideScoreboard = await appDatabasePrimaryFunctions.ref(experiencePath(selectedExperience, 'settings/hideScoreboard')).once('value');
        this.setState({ hideScoreboard: hideScoreboard.val() === true });
    }

    handleExperienceChange(experienceId) {
        // Detach the current experience's binding before re-binding to the new one
        base.removeBinding(this.homeButtonsBuiltRef);
        this.setState({
            selectedExperience: experienceId,
            itemsList: [],
            backgroundImage: null,
            enabledModules: {},
            hideScoreboard: false,
            hasUnsavedChanges: false,
            loading: true
        }, () => this.bindData());
    }

    componentWillUnmount() {
        if (this.unsubscribeScope) this.unsubscribeScope();
        if (this.unregisterScopeGuard) this.unregisterScopeGuard();
        if (this.state.imageUrlPreview) {
            URL.revokeObjectURL(this.state.imageUrlPreview.preview);
        }
        base.removeBinding(this.homeButtonsBuiltRef);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleBeforeUnload(event) {
        if (this.state.hasUnsavedChanges) {
            const message = 'You have unsaved changes. Are you sure you want to leave?';
            event.returnValue = message;
            return message;
        }
    }

    onDrop(files, rejected, myArgument) {
        if (rejected.length > 0) {
            ErrorMessage.fire({
                title: 'Image cannot be uploaded',
                text: 'Make sure the image is less than 2mbs and it is an accepted file type'
            })
            return;
        }
        this.setState({ loading: true, hasUnsavedChanges: true })

        this.UploadImage.upload_file(files[0]).then(res => {
            this.setState({ loading: false })
            if (res.error) {
                ErrorMessage.fire({
                    title: 'Image cannot be uploaded',
                    text: res.error,
                })
            } else if (res.imageUrl) {
                const nameToUpdate = myArgument + "Preview"
                const fileToUpdate = files[0]
                this.setState({
                    [myArgument]: res.imageUrl,
                    [nameToUpdate]: ({
                        fileToUpdate,
                        preview: URL.createObjectURL(fileToUpdate)
                    })
                });
            } else {
                ErrorMessage.fire({
                    title: 'Image cannot be uploaded',
                    text: 'Something went wrong, please re-upload your image and try again!'
                })
            }
        })
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [target.name]: value, hasUnsavedChanges: true });
    }

    isModuleButtonType(buttonType) {
        return ['isLeagueScoresModule', 'isSeasonGamesModule', 'isScheduleModule', 'isStandingsModule', 'isPlayerLeadersModule', 'isRosterModule', 'isScoreboardModule', 'isSlider'].includes(buttonType);
    }

    isSliderAdded() {
        return this.state.itemsList.some(item => item.buttonType === 'isSlider');
    }

    getModuleLabel(buttonType) {
        const labels = {
            isLeagueScoresModule: 'League Scores Module',
            isSeasonGamesModule: 'Season Games Module',
            isScheduleModule: 'Schedule Module',
            isStandingsModule: 'Standings Module',
            isPlayerLeadersModule: 'Player Leaders Module',
            isRosterModule: 'Roster Module',
            isScoreboardModule: 'Scoreboard',
            isSlider: 'Top Carousel'
        };
        return labels[buttonType] || buttonType;
    }

    getUsedModuleTypes() {
        return this.state.itemsList
            .filter(item => this.isModuleButtonType(item.buttonType))
            .map(item => item.buttonType);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.loading) {
            return;
        }

        const { itemName, itemLink, itemsList, buttonType, imageUrl, itemToEdit, openOutsideApp, buttonSizeRatio=1 } = this.state;
        const isModule = this.isModuleButtonType(buttonType);

        // Modules don't need name or image validation
        if (!isModule) {
            if (!itemName || itemName.length > 50) {
                ErrorMessage.fire({
                    title: 'Oh uh!',
                    text: 'Name cannot be longer than 50 characters or be left blank!',
                });
                return;
            }

            const image = imageUrl || this.state.editImage || "";

            if (!image) {
                ErrorMessage.fire({
                    title: 'Not all fields filled out!',
                    text: 'Please enter them and try again'
                });
                return;
            }

            // typeof NaN === 'number', so the old check passed an emptied field
            // straight through — and NaN < 1 is false, so the range check below
            // let it past too. Firebase then refused the whole homeButtonsBuilt
            // node, so one cleared field blocked saving every button on the screen.
            if(!Number.isFinite(parseInt(buttonSizeRatio))) {
                ErrorMessage.fire({
                    title: 'Button Width Of Screen Ratio invalid ',
                    text: 'It must be a number'
                });
                return;
            } else if(parseInt(buttonSizeRatio) < 1) {
                ErrorMessage.fire({
                    title: 'Invalid Button Width Value',
                    text: 'It must be a 1 or greater'
                });
                return;
            }
        }

        // Firebirds: the old (live) app hard-codes radio and website-link buttons, so a
        // dynamic 'isRadio'/'isWebsiteLink' button would duplicate them. Persist them under
        // types the old app doesn't recognize ('isRadioButton'/'isWebsiteLinkButton') — they
        // hide there (no dup) and the new app renders them. Invisible to admins, who just
        // pick the normal Radio Button / Website Link.
        const isFirebirds = process.env.REACT_APP_FIREBASE_PROJECT_ID === 'coachella-firebirds-app';
        const firebirdsTypeAliases = { isRadio: 'isRadioButton', isWebsiteLink: 'isWebsiteLinkButton' };
        const persistedButtonType = isFirebirds ? (firebirdsTypeAliases[buttonType] || buttonType) : buttonType;

        const itemToSave = {}
        itemToSave['header'] = isModule ? this.getModuleLabel(buttonType) : itemName;
        itemToSave['link'] = itemLink;
        itemToSave['image'] = isModule ? '' : (imageUrl || this.state.editImage || "");
        itemToSave['buttonType'] = persistedButtonType || 'isWebsiteLink';
        itemToSave['buttonSizeRatio'] = isModule ? 1 : parseInt(buttonSizeRatio);
        itemToSave['openOutsideApp'] = openOutsideApp;
        itemToSave['order'] = (this.state.itemToEdit && this.state.itemToEdit.order) || itemsList.length + 1;
        this.setState({ loading: true })
        itemToSave['id'] = (this.state.itemToEdit && this.state.itemToEdit.key) || appDatabasePrimaryFunctions.ref().push().key;

        let updatedItemsList = [...itemsList];
        if (itemToEdit) {
            updatedItemsList = updatedItemsList.map(item => item.key === itemToSave.id ? itemToSave : item);
        } else {
            updatedItemsList.push(itemToSave);
        }

        this.setState({
            itemsList: updatedItemsList,
            itemName: "",
            itemLink: "",
            imageUrl: "",
            itemToEdit: null,
            editingItem: false,
            openOutsideApp: false,
            modal: false,
            buttonType: 'isWebsiteLink',
            loading: false,
            hasUnsavedChanges: true,
            buttonSizeRatio: 1
        });
    }

    async saveChanges() {
        this.setState({ loading: true });
        const itemListCopyObject = {};
        this.state.itemsList.forEach(item => {
            itemListCopyObject[item.id || item.key] = { ...item, key: null, id: item.id || item.key };
        });

        await appDatabasePrimaryFunctions.ref(experiencePath(this.state.selectedExperience, 'homeButtonsBuilt')).set(itemListCopyObject);
        this.setState({ loading: false, hasUnsavedChanges: false });
        Toast.fire({
            title: 'Changes saved successfully!'
        });
    }

    editItem(event) {
        event.preventDefault();
        const item = this.state.itemsList[event.currentTarget.value];
        this.setState({
            modal: true,
            itemName: item.header,
            itemLink: item.link,
            imageUrl: item.image,
            itemToEdit: item,
            editingItem: true,
            // Map persisted Firebirds aliases back to their normal options in the UI.
            // A button created before buttonType existed reads back without
            // one. Left undefined it reaches the write and Firebase refuses the
            // whole node, so every other button fails to save with it.
            buttonType: ({ isRadioButton: 'isRadio', isWebsiteLinkButton: 'isWebsiteLink' })[item.buttonType] || item.buttonType || 'isWebsiteLink',
            openOutsideApp: !!item.openOutsideApp,
            hasUnsavedChanges: true,
            buttonSizeRatio: item.buttonSizeRatio
        });
    }

    async deleteItem(e) {
        e.preventDefault();
        const index = e.currentTarget.value;
        const response = await WarningMessage.fire({
            title: 'Delete?',
            text: 'Are you sure you want to do this?  You will no longer be able to use this anymore',
            confirmButtonText: 'Delete'
        });

        if (response.value) {
            let updatedItemsList = this.state.itemsList.filter((_, idx) => idx !== parseInt(index));
            updatedItemsList = updatedItemsList.map((item, idx) => {
                item.order = idx + 1;
                return item;
            });

            this.setState({ itemsList: updatedItemsList, hasUnsavedChanges: true });
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            itemName: "",
            itemLink: "",
            imageUrl: "",
            itemToEdit: null,
            editingItem: false,
            buttonType: 'isWebsiteLink',
            openOutsideApp: false,
            hasUnsavedChanges: true,
            buttonSizeRatio: 1
        });
    }

    async changeOrder(item, direction, index) {
        let itemsListCopyArray = this.state.itemsList || [];
        let originalOrder = item.order || index;
        const itemId = item.id || item.key;

        if ((originalOrder === 1 && direction === 1) || (originalOrder === itemsListCopyArray.length && direction === -1)) {
            return;
        }

        let newOrder = originalOrder - direction;
        itemsListCopyArray = itemsListCopyArray.map((item, idx) => {
            if (item.order === newOrder) {
                item.order = originalOrder;
            } else if (item.id === itemId) {
                item.order = newOrder;
            }
            return item;
        });

        this.setState({ itemsList: itemsListCopyArray, hasUnsavedChanges: true });
    }

    render() {
        const isDev = process.env.REACT_APP_FIREBASE_PROJECT_ID === "anothertestdb-be6c5";
        const isCheckers = process.env.REACT_APP_FIREBASE_PROJECT_ID === "checkersdbtest";
        const { loading, itemsList = [], imageUrlPreview = {}, backgroundImage, hasUnsavedChanges } = this.state;
        return (
            <div className="admin-wrapper">
                <div className="loading-screen" style={{ display: loading ? 'block' : 'none' }} />
                <SideMenu />
                <TopMenu />
                <div className="admin-main-panel">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="admin-form-box">
                                <div>
                                    <div className="admin-page-head" style={{ margin: 0 }}>
                                        <p className="admin-eyebrow">App layout</p>
                                        <p className="admin-header-text">Home Buttons</p>
                                        <p className="admin-page-sub">The main buttons on your app&rsquo;s home screen. Artwork is 1400&times;450.</p>
                                    </div>


                                    <div className="admin-actions">
                                        <button className="btn btn-primary save-changes-button" onClick={this.saveChanges}>Save changes</button>
                                        <button className="btn create-prize-button" onClick={this.toggle}>Add item</button>
                                        {hasUnsavedChanges &&
                                            <span className="admin-unsaved">You have unsaved changes</span>
                                        }
                                    </div>

                                    <div className="admin-tile-grid">
                                        {
                                            itemsList.sort((a, b) => a.order > b.order ? 1 : -1).map((item, i) => {
                                                let orderNumber = item.order || i + 1;
                                                return (
                                                    <div key={i} className="admin-tile">
                                                        <div className="admin-tile-art">
                                                            {item.image ? (
                                                                <img src={item.image} alt="" />
                                                            ) : this.isModuleButtonType(item.buttonType) ? (
                                                                <div className="admin-tile-module">
                                                                    {this.getModuleLabel(item.buttonType)}
                                                                </div>
                                                            ) : (
                                                                <div className="admin-tile-empty">No image</div>
                                                            )}
                                                        </div>

                                                        <div className="admin-tile-body">
                                                            <p className="admin-tile-name">{item.header}</p>
                                                            {/* full URLs used to print in the card and stretched
                                                                one column to several times the height of its row */}
                                                            {item.link &&
                                                                <p className="admin-tile-link" title={item.link}>{item.link}</p>
                                                            }
                                                        </div>

                                                        <div className="admin-tile-foot">
                                                            {itemsList.length > 1 &&
                                                                <span className="admin-tile-order">
                                                                    <button
                                                                        type="button"
                                                                        className="admin-order-btn"
                                                                        aria-label={`Move ${item.header} earlier`}
                                                                        disabled={orderNumber <= 1}
                                                                        onClick={() => this.changeOrder(item, 1, i + 1)}
                                                                    >
                                                                        <span className="fa fa-chevron-left"/>
                                                                    </button>
                                                                    <b>{orderNumber}</b>
                                                                    <button
                                                                        type="button"
                                                                        className="admin-order-btn"
                                                                        aria-label={`Move ${item.header} later`}
                                                                        disabled={itemsList.length <= i + 1}
                                                                        onClick={() => this.changeOrder(item, -1, i + 1)}
                                                                    >
                                                                        <span className="fa fa-chevron-right"/>
                                                                    </button>
                                                                </span>
                                                            }
                                                            <span className="admin-row-actions">
                                                                <button type="button" className="admin-icon-btn" aria-label="Edit button" title="Edit button" onClick={this.editItem.bind(this)} value={i}><span className="fa fa-pencil" aria-hidden="true"/></button>
                                                                <button type="button" className="admin-icon-btn is-danger" aria-label="Delete button" title="Delete button" onClick={this.deleteItem.bind(this)} value={i}><span className="fa fa-trash-o" aria-hidden="true"/></button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <Preview imagePreviews={itemsList} backgroundImage={backgroundImage} />
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{ width: '90%' }} id="myModal">
                    <div className="loading-screen" style={{ display: this.state.loading ? 'block' : 'none' }} />
                    <ModalHeader toggle={this.toggle}>Add Item</ModalHeader>
                    <ModalBody>
                        <div className="container-out">
                            <div className="question-box question-form">
                                <form className="pl-3 pr-3" onSubmit={this.handleSubmit} id="create-email-form">
                                    {!this.isModuleButtonType(this.state.buttonType) && (
                                        <div className="form-group">
                                            <label htmlFor="itemName">Name</label>
                                            <input id="itemName" name="itemName" type="text" className="form-control" value={this.state.itemName} onChange={this.handleChange} placeholder="Name" />
                                        </div>
                                    )}
                                    <div className="row">
                                        {/*{process.env.REACT_APP_HAS_PRIZES === "true" && (*/}
                                            <>
                                                <div className="col-12 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-check">
                                                                <input
                                                                    id="isWebsiteLink"
                                                                    name="buttonType"
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    value="isWebsiteLink"
                                                                    checked={this.state.buttonType === "isWebsiteLink"}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="isWebsiteLink">
                                                                    Website Link
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {process.env.REACT_APP_HAS_TICKETMASTER === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isTicketMaster"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isTicketMaster"
                                                                        checked={this.state.buttonType === "isTicketMaster"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isTicketMaster">
                                                                        Ticketmaster SDK Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-md-4">
                                                            <div className="form-check">
                                                                <input
                                                                    id="isAnotherSliderHolder"
                                                                    name="buttonType"
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    value="isAnotherSliderHolder"
                                                                    checked={this.state.buttonType === "isAnotherSliderHolder"}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="isAnotherSliderHolder">
                                                                    Last Slider Item Link
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        {process.env.REACT_APP_HAS_PLAYER_PICK === "true" && (
                                                            <>
                                                                <div className="col-md-4">
                                                                    <div className="form-check">
                                                                        <input
                                                                            id="isPlayerPick"
                                                                            name="buttonType"
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            value="isPlayerPick"
                                                                            checked={this.state.buttonType === "isPlayerPick"}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="isPlayerPick">
                                                                            Player Pick Button
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <div className="form-check">
                                                                        <input
                                                                            id="isLeaderboard"
                                                                            name="buttonType"
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            value="isLeaderboard"
                                                                            checked={this.state.buttonType === "isLeaderboard"}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="isLeaderboard">
                                                                            Leaderboard Button
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <div className="row">
                                                        {process.env.REACT_APP_HAS_BADGES === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isBadges"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isBadges"
                                                                        checked={this.state.buttonType === "isBadges"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isBadges">
                                                                        Badges Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {process.env.REACT_APP_HAS_CHECK_IN === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isCheckIn"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isCheckIn"
                                                                        checked={this.state.buttonType === "isCheckIn"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isCheckIn">
                                                                        Check In Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {process.env.REACT_APP_HAS_PRIZES === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isPrizes"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isPrizes"
                                                                        checked={this.state.buttonType === "isPrizes"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isPrizes">
                                                                        Reward Store Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <div className="row">
                                                        {process.env.REACT_APP_HAS_RADIO === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isRadio"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isRadio"
                                                                        checked={this.state.buttonType === "isRadio"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isRadio">
                                                                        Radio Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {process.env.REACT_APP_HAS_CUE_AUDIO === "true" && (
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        id="isCueAudio"
                                                                        name="buttonType"
                                                                        type="radio"
                                                                        className="form-check-input"
                                                                        value="isCueAudio"
                                                                        checked={this.state.buttonType === "isCueAudio"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="isCueAudio">
                                                                        Cue Audio Button
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Slider option - only show if not already added */}
                                                {(() => {
                                                    const sliderAdded = this.isSliderAdded();
                                                    const isEditingSlider = this.state.itemToEdit?.buttonType === 'isSlider';
                                                    const sliderAvailable = !sliderAdded || isEditingSlider;

                                                    if (!sliderAvailable) return null;

                                                    return (
                                                        <div className="col-12 mb-3">
                                                            <p style={{ fontWeight: 'bold', marginBottom: 10, marginTop: 10, borderTop: '1px solid #eee', paddingTop: 10 }}>
                                                                Components
                                                            </p>
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <div className="form-check">
                                                                        <input
                                                                            id="isSlider"
                                                                            name="buttonType"
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            value="isSlider"
                                                                            checked={this.state.buttonType === "isSlider"}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="isSlider">
                                                                            Top Carousel
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })()}

                                                {/* Module button types - only show if enabled in Settings and not already added */}
                                                {(() => {
                                                    const usedModules = this.getUsedModuleTypes();
                                                    const isEditing = !!this.state.itemToEdit;
                                                    const editingType = this.state.itemToEdit?.buttonType;

                                                    // Check which modules are available (enabled and not used, or currently being edited)
                                                    const leagueScoresAvailable = this.state.enabledModules?.leagueScores?.enabled &&
                                                        (!usedModules.includes('isLeagueScoresModule') || editingType === 'isLeagueScoresModule');
                                                    const seasonGamesAvailable = this.state.enabledModules?.seasonGames?.enabled &&
                                                        (!usedModules.includes('isSeasonGamesModule') || editingType === 'isSeasonGamesModule');
                                                    const scheduleAvailable = this.state.enabledModules?.schedule?.enabled &&
                                                        (!usedModules.includes('isScheduleModule') || editingType === 'isScheduleModule');
                                                    const standingsAvailable = this.state.enabledModules?.standings?.enabled &&
                                                        (!usedModules.includes('isStandingsModule') || editingType === 'isStandingsModule');
                                                    const playerLeadersAvailable = this.state.enabledModules?.playerLeaders?.enabled &&
                                                        (!usedModules.includes('isPlayerLeadersModule') || editingType === 'isPlayerLeadersModule');
                                                    const rosterAvailable = this.state.enabledModules?.roster?.enabled &&
                                                        (!usedModules.includes('isRosterModule') || editingType === 'isRosterModule');
                                                    // Not switched on in Settings like the others: the scoreboard is always
                                                    // there to place, and Settings' Hide Scoreboard is its off switch.
                                                    const scoreboardAvailable = !usedModules.includes('isScoreboardModule') || editingType === 'isScoreboardModule';

                                                    const anyAvailable = leagueScoresAvailable || seasonGamesAvailable || scheduleAvailable || standingsAvailable || playerLeadersAvailable || rosterAvailable || scoreboardAvailable;

                                                    if (!anyAvailable) return null;

                                                    return (
                                                        <div className="col-12 mb-3">
                                                            <p className="admin-eyebrow" style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--line-soft)' }}>
                                                                Modules
                                                            </p>
                                                            <div className="row">
                                                                {leagueScoresAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isLeagueScoresModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isLeagueScoresModule"
                                                                                checked={this.state.buttonType === "isLeagueScoresModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isLeagueScoresModule">
                                                                                League Scores Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {seasonGamesAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isSeasonGamesModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isSeasonGamesModule"
                                                                                checked={this.state.buttonType === "isSeasonGamesModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isSeasonGamesModule">
                                                                                Season Games Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {scheduleAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isScheduleModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isScheduleModule"
                                                                                checked={this.state.buttonType === "isScheduleModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isScheduleModule">
                                                                                Schedule Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {standingsAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isStandingsModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isStandingsModule"
                                                                                checked={this.state.buttonType === "isStandingsModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isStandingsModule">
                                                                                Standings Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="row" style={{ marginTop: 10 }}>
                                                                {playerLeadersAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isPlayerLeadersModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isPlayerLeadersModule"
                                                                                checked={this.state.buttonType === "isPlayerLeadersModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isPlayerLeadersModule">
                                                                                Player Leaders Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {rosterAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isRosterModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isRosterModule"
                                                                                checked={this.state.buttonType === "isRosterModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isRosterModule">
                                                                                Roster Module
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {scoreboardAvailable && (
                                                                    <div className="col-md-4">
                                                                        <div className="form-check">
                                                                            <input
                                                                                id="isScoreboardModule"
                                                                                name="buttonType"
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                value="isScoreboardModule"
                                                                                checked={this.state.buttonType === "isScoreboardModule"}
                                                                                onChange={this.handleChange}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="isScoreboardModule">
                                                                                Scoreboard
                                                                            </label>
                                                                        </div>
                                                                        <p className="admin-hint">
                                                                            {this.state.hideScoreboard
                                                                                ? 'Hide Scoreboard is on in Settings, so fans will not see it here until that is switched off.'
                                                                                : 'Moves the score strip from the top of the Home screen to this spot, once fans have the app release that can move it.'}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })()}
                                            </>
                                        {/*)}*/}
                                        {!this.isModuleButtonType(this.state.buttonType) && (
                                            <div className="col-12 mb-3">
                                                <div className="form-group">
                                                    <label htmlFor="buttonSizeRatio">Buttons per row</label>
                                                    <p className="admin-hint">1 fills the screen width. 2 puts two buttons side by side.</p>
                                                    <input
                                                        id="buttonSizeRatio"
                                                        name="buttonSizeRatio"
                                                        type="number"
                                                        min={1}
                                                        step={1}
                                                        className="form-control"
                                                        value={this.state.buttonSizeRatio || 1}
                                                        onChange={this.handleChange}
                                                        placeholder="1"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {this.state.buttonType === "isWebsiteLink" && (
                                            <div className="col-12 mb-3">
                                                <div className="form-group">
                                                    <label htmlFor="itemLink">Link:</label>
                                                    <input
                                                        id="itemLink"
                                                        name="itemLink"
                                                        type="url"
                                                        className="form-control"
                                                        value={this.state.itemLink}
                                                        onChange={this.handleChange}
                                                        placeholder="https://linktogoto.com"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(this.state.buttonType === "isWebsiteLink" ||
                                          this.state.buttonType === "isSeasonGamesModule" ||
                                          this.state.buttonType === "isLeagueScoresModule" ||
                                          this.state.buttonType === "isScheduleModule") && (
                                            <div className="col-12 mb-3">
                                                <div className="form-check">
                                                    <input
                                                        id="openOutsideApp"
                                                        name="openOutsideApp"
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={this.state.openOutsideApp}
                                                        onChange={this.handleChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="openOutsideApp"
                                                    >
                                                        Open links outside the app
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {!this.isModuleButtonType(this.state.buttonType) && (
                                        <div className="form-group" align="center">
                                            <label style={{ width: '100%' }}>
                                                Image
                                                {(imageUrlPreview.preview || this.state.imageUrl) &&
                                <button type="button" className="admin-clear-image" aria-label="Remove image" onClick={() => this.setState({ imageUrl: null, imageUrlPreview: {} })}>Remove</button>
                            }
                                            </label>
                                            <img src={this.state.imageUrl} width="auto" height="auto" style={{ display: this.state.editingItem ? '' : 'none', maxWidth: '100%', maxHeight: 100 }} alt="" />
                                            <BasicDropzone
                                                onDrop={(acceptedFiles, fileRejections) => this.onDrop(acceptedFiles, fileRejections, "imageUrl")}
                                                preview={imageUrlPreview.preview}
                                            />
                                        </div>
                                    )}
                                    <div className="admin-modal-actions">
                                        <button type="button" className="btn btn-secondary" onClick={this.toggle}>Cancel</button>
                                        <button className="btn btn-primary submit-button" id="submitButton">
                                            {this.state.editingItem ? 'Save changes' : 'Add button'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default SetUpHomeScreen;
